<canvas id="lens" class="glass"></canvas>
<app-preloader></app-preloader>
<router-outlet></router-outlet>
